module.exports = __webpack_public_path__ + "img/wechat-code.ec7810c3.jpg";